const {JustDate} = require('./JustDate')

/**
 * This is a payment history model
 */
class PaymentHistory {
    /**
     * @param {number} payment
     * @param {string} nickName
     * @param {JustDate} date
     * @param {Boolean} adminPaid
     */
    constructor(
        payment=0.00,
        nickName='',
        date=new JustDate(),
        adminPaid=false,
    ) {
        this.payment = payment
        this.nick_name = nickName
        this.date = date
        this.admin_paid = adminPaid
    }

    /**
     * Create a new PaymentHistory from json
     * @param {json} json
     * @return {PaymentHistory}
     */
    static from(json) {
        const paymentHistory = Object.assign(new PaymentHistory(), json)
        if (paymentHistory.date) {
            paymentHistory.date = new JustDate(paymentHistory.date)
        }

        return paymentHistory
    }
}

module.exports = {
    PaymentHistory,
}
